// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__qdfQF","faqItemList":"FAQ_faqItemList__VXU-4"};